var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left col-4" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.payslip")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            _c(
              "div",
              { staticClass: "action" },
              [
                _c("BaseFilterDocProcessStatus", {
                  attrs: { docType: "prl", status: _vm.query.status },
                  on: { onSelect: _vm.handleSelectStatus }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("base-table", {
            attrs: { pagination: _vm.pagination },
            on: { onPageChange: _vm.handlePageChange },
            scopedSlots: _vm._u([
              {
                key: "thead",
                fn: function() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticStyle: { "min-width": "110px" } }, [
                          _vm._v(_vm._s(_vm.$t("series.prl")))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "min-width": "110px" } }, [
                          _vm._v(_vm._s(_vm.$t("series.pe")))
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.debttotal")))]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("message.paidtotal")))]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("apps.payroll.message.grandtotal"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "max-width": "100px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.payroll.message.employeelistcount")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "max-width": "100px" } }, [
                          _vm._v(_vm._s(_vm.$t("message.status")))
                        ])
                      ])
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "tbody",
                fn: function() {
                  return [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _vm.empty
                            ? _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "7" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("message.notfounddata")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.data, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "PaySlipEdit",
                                        query: {
                                          id: item.prlId,
                                          code: item.prlCode
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.prlCode) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "vertical-align": "top" } },
                              _vm._l(item.payments, function(payment, index) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("router-link-custom", {
                                      attrs: {
                                        to: {
                                          name: "AccountsPaymentEntryEdit",
                                          query: {
                                            pe_id: payment.peId,
                                            pe_code: payment.peCode
                                          }
                                        },
                                        text: payment.peCode,
                                        status: {
                                          text: _vm.getPaymentStatus(
                                            payment,
                                            _vm.$t
                                          ).message,
                                          color: _vm.getColorFormStatus(
                                            _vm.getPaymentStatus(
                                              payment,
                                              _vm.$t
                                            ).status
                                          ),
                                          type: "icon"
                                        },
                                        to_appid: 12,
                                        current_appid: 14
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.status === "approved"
                                      ? _vm.getNumber(item.process.debit)
                                      : _vm.getNumber(0)
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.status === "approved"
                                      ? _vm.getNumber(
                                          item.net - item.process.debit
                                        )
                                      : _vm.getNumber(0)
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getNumber(item.net)) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.numberel(item.appliedCount)) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("BaseDocumentProcessStatus", {
                                  attrs: {
                                    docType: "prl",
                                    status: item.process.status
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        })
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb104268", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb104268","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/payroll/payslip/List.vue
// module id = null
// module chunks = 